"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Paintbrush, Wrench, Sparkles } from "lucide-react";
export default function ServicePackages() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const packages = [{
    id: 1,
    icon: Paintbrush,
    title: "Full Panel Respray",
    features: ["OEM-Grade Paint Matching", "Complete Surface Preparation", "Multi-Layer Clear Coat", "Lifetime Warranty on Paint"],
    detailPath: "/ServicesPage"
  }, {
    id: 2,
    icon: Wrench,
    title: "Crash Repair & Restoration",
    features: ["Structural Frame Analysis", "Precision Welding Services", "Dent Removal & Bodywork", "Full Damage Assessment"],
    detailPath: "/ServicesPage"
  }, {
    id: 3,
    icon: Sparkles,
    title: "Custom Graphics Package",
    features: ["Unique Design Consultation", "Premium Vinyl Application", "Custom Decal Creation", "Color-Matched Graphics"],
    detailPath: "/ServicesPage"
  }];
  return <section className="bg-light-background py-16 md:py-24" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground-light mb-4">Services Provided</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Professional motorcycle restoration services tailored to your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((pkg, i) => {
          const Icon = pkg.icon;
          return <Card key={pkg.id} data-index={i} className={`bg-background border border-border hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
                <CardHeader>
                  <div className="mb-4">
                    <Icon className="w-12 h-12 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-display font-semibold text-foreground-light">
                    {pkg.title}
                  </CardTitle>
                </CardHeader>

                <CardContent>
                  <ul className="space-y-3">
                    {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
                        <span className="mt-1 inline-block w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
                        
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter>
                  <Link to={pkg.detailPath} className="w-full">
                    <Button variant="default" className="w-full bg-secondary text-foreground-secondary hover:bg-secondary-hover transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02]">
                      View Details
                    </Button>
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}